import React from 'react';
import Modal from 'react-modal';
import useModalStore from 'hooks/useModalStore';
import { observer } from 'mobx-react';
import style from './style.module.scss';

Modal.setAppElement('#root');

const AlertModal = observer(({ option }) => {
  const modalStore = useModalStore();

  if (!option) {
    return <></>;
  }

  return (
    <Modal
      isOpen={option.isOpen}
      onRequestClose={() => {
        modalStore.closeModal();
      }}
      style={{
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          padding: 0,
          transform: 'translate(-50%, -50%)',
          borderRadius: 0
        }
      }}
      overlayClassName={style.overlay}
    >
      <div className={style.content}>
        <div
          className={style.alertText}
          dangerouslySetInnerHTML={{
            __html: option.message.replace(/\n/g, '<br/>')
          }}
        />

        <div className={style.action}>
          <button
            onClick={() => {
              modalStore.closeModal();
            }}
          >
            확인
          </button>
        </div>
      </div>
    </Modal>
  );
});

export { AlertModal };
